import React from "react";
import "./WeekCalendar.css";
import { CourseGroupTable } from "./CourseGroupTable";
import * as t from "./types";

// this should render all the CourseGroupTables for a week (only receives the correct week)
// take care to style like the "trainingsplan"

interface WeekCalendarProps {
  activeWeek: t.IWeek;
  courseGroups: t.ICourseGroup[];
  notifyUpdate: (data: t.IData) => void;
}

export const WeekCalendar = (props: WeekCalendarProps) => {
  const { activeWeek, courseGroups, notifyUpdate } = props;
  // console.log("render WeekCal");
  // console.log(props);
  return (
    <div className="week-calendar">
      <h1>{activeWeek.name}</h1>
      <table>
        {courseGroups.map((cg) => {
          return (
            <CourseGroupTable
              activeWeek={activeWeek}
              courseGroup={cg}
              notifyUpdate={notifyUpdate}
            />
          );
        })}
      </table>
    </div>
  );
};
